import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sbqs",
  "use": "icon-sbqs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sbqs\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 128a384 384 0 1 0 0 768A384 384 0 0 0 512 128z\" fill=\"#ffffff\" p-id=\"15322\" /><path d=\"M621.696 532.48L365.824 274.816l-90.88 90.24L530.944 622.72z\" fill=\"#ffffff\" p-id=\"15323\" /><path d=\"M254.336 448.768l193.984-192.32-213.632-18.432z\" fill=\"#ffffff\" p-id=\"15324\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol